(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function accordion() {
  var toggle = $('.accordion button');
  var inner = $('.accordion-inner');
  var item = $('.accordion > li');
  var imgHolder = $('.accordion-right .img-holder');
  var firstItem = $('.accordion > li:first-child');
  var firstImg = 'url("' + firstItem.data('image') + '")';
  imgHolder.css('background-image', firstImg);

  function accordionImg() {
    var preloadImgs = [];

    for (var i = 0; i < item.length; i++) {
      preloadImgs.push(new Image());
      preloadImgs[preloadImgs.length - 1].src = item[i].getAttribute('data-image');
      $(item[i]).on('click', function () {
        this.src = this.getAttribute('data-image');
        var imgURL = 'url("' + this.src + '")';
        imgHolder.css('background-image', imgURL);
      });
    }
  }

  toggle.on('click', function () {
    if ($(this).parent().hasClass('open')) {
      inner.slideUp();
      item.removeClass('open');
    } else {
      inner.slideUp();
      item.removeClass('open');
      $(this).parent().addClass('open');
      $(this).next().slideDown();
      accordionImg();
    }
  });
}

function accordionInit() {
  if ($('.accordion').length) {
    accordion();
  }
}

var _default = accordionInit;
exports["default"] = _default;

},{}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function careersFilter() {
  // CAREERS PAGE LEVER FILTERING
  var url = 'https://api.lever.co/v0/postings/crowdriff?group=team&mode=json'; //Checking for potential Lever source or origin parameters

  var pageUrl = window.location.href;
  var leverParameter = '';
  var trackingPrefix = '?lever-';

  if (pageUrl.indexOf(trackingPrefix) >= 0) {
    // Found Lever parameter
    var pageUrlSplit = pageUrl.split(trackingPrefix);
    leverParameter = '?lever-' + pageUrlSplit[1];
  } //Functions for checking if the variable is unspecified


  function cleanString(string) {
    if (string) {
      var cleanString = string.replace(/\s+/ig, "");
      return cleanString;
    } else {
      return "Uncategorized";
    }
  }

  function nullCheck(string) {
    if (!string) {
      var result = 'Uncategorized';
      return result;
    } else {
      return string;
    }
  }

  function createJobs(_data) {
    for (var i = 0; i < _data.length; i++) {
      var team = nullCheck(_data[i].title);
      var teamCleanString = cleanString(team);
      $('#jobs-container .jobs-teams').append('<li><button class="' + teamCleanString + '">' + team + '</button></li>');
    }

    for (var i = 0; i < _data.length; i++) {
      for (var j = 0; j < _data[i].postings.length; j++) {
        var posting = _data[i].postings[j];
        var title = posting.text;
        var description = posting.description; //Making each job description shorter than 250 characters

        var shortDescription = $.trim(description).substring(0, 250).replace('\n', ' ') + "...";
        var location = nullCheck(posting.categories.location);
        var locationCleanString = cleanString(location);
        var commitment = nullCheck(posting.categories.commitment);
        var commitmentCleanString = cleanString(commitment);
        var team = nullCheck(posting.categories.team);
        var teamCleanString = cleanString(team);
        var link = posting.hostedUrl + leverParameter;
        $('#jobs-container .jobs-list').append('<li class="job ' + teamCleanString + ' ' + locationCleanString + ' ' + commitmentCleanString + '"><a href="' + link + '"" target="_blank">' + '<h3 class="job-title" href="' + link + '"">' + title + '</h3>' + '<p class="tags"><span>' + team + ', </span><span>' + location + ', </span><span>' + commitment + '</span></p>' + '</a></li>');
      }
    }
  } //Creating filter buttons for sorting your jobs


  function activateButtons(_data) {
    $('.jobs-teams').on("click", "button", function (e) {
      e.preventDefault();

      for (var i = 0; i < _data.length; i++) {
        var teamRaw = _data[i].title;
        var team = cleanString(teamRaw);
        var jobs = $(".jobs-list");

        if ($(this).hasClass('All')) {
          $(".jobs-teams").find("button").removeClass("active");
          $(this).addClass('active');
          jobs.find(".job").fadeIn("fast");
        }

        if ($(this).hasClass(team)) {
          if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            $(".jobs-teams button.All").addClass("active");
            jobs.find(".job").fadeIn("fast");
          } else {
            $(".jobs-teams").find("button").removeClass("active");
            $(this).addClass("active");
            jobs.find("." + team).fadeIn("fast");
            jobs.find(".job").not("." + team).fadeOut("fast");
          }
        }
      }
    });
  } //Fetching job postings from Lever's postings API


  $.ajax({
    dataType: "json",
    url: url,
    success: function success(data) {
      createJobs(data);
      activateButtons(data);
    }
  });
}

function careersFilterInit() {
  if ($('.job-postings').length) {
    careersFilter();
  }
}

var _default = careersFilterInit;
exports["default"] = _default;

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function carousels() {
  $('.carousel-wide').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    swipeToSlide: true,
    autoplay: false,
    nextArrow: '<button class="arrow-next"><img src="https://cdn2.hubspot.net/hubfs/2719325/Website/arrow-right-dark.svg" alt="Right-facing arrow"></button>',
    prevArrow: '<button class="arrow-prev"><img src="https://cdn2.hubspot.net/hubfs/2719325/Website/arrow-left-dark.svg" alt="Left-facing arrow"></button>',
    responsive: [{
      breakpoint: 1024,
      settings: {
        arrows: false,
        slidesToShow: 2,
        autoplay: true,
        autoplaySpeed: 4000
      }
    }, {
      breakpoint: 767,
      settings: {
        arrows: false,
        centerMode: true,
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 4000
      }
    }]
  });
  $('.carousel-wrapper').each(function () {
    var num = $(this).find('.carousel-item').length;

    if (num > 3) {
      $(this).addClass('run');
    }
  });
  $('.carousel-wrapper.run').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    swipeToSlide: true,
    autoplay: false,
    nextArrow: '<button class="arrow-next"><img src="https://cdn2.hubspot.net/hubfs/2719325/Website/arrow-right-dark.svg" alt="Right-facing arrow"></button>',
    prevArrow: '<button class="arrow-prev"><img src="https://cdn2.hubspot.net/hubfs/2719325/Website/arrow-left-dark.svg" alt="Left-facing arrow"></button>',
    responsive: [{
      breakpoint: 1024,
      settings: {
        arrows: false,
        slidesToShow: 2,
        dots: true
      }
    }, {
      breakpoint: 767,
      settings: {
        arrows: false,
        slidesToShow: 1,
        dots: true
      }
    }]
  });
  $('.carousel-case-wrapper').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    dots: true,
    fade: true,
    responsive: [{
      breakpoint: 950,
      settings: {
        adaptiveHeight: true
      }
    }]
  });
}

function carouselsInit() {
  if ($('.carousel-wide').length || $('.carousel-wrapper').length || $('.carousel-case-wrapper').length) {
    carousels();
  }
}

var _default = carouselsInit;
exports["default"] = _default;

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function changingText() {
  var changingTexts = ["Getting discovered", "Increasing views", "Engaging locals", "Driving bookings"];
  var textQueue = shuffleArray(changingTexts.slice());

  function shuffleArray(array) {
    for (var i = array.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var _ref = [array[j], array[i]];
      array[i] = _ref[0];
      array[j] = _ref[1];
    }

    return array;
  }

  function changeText() {
    var changingPart = document.getElementById("changingPart");

    if (textQueue.length === 0) {
      textQueue = shuffleArray(changingTexts.slice());
    }

    var nextText = textQueue.pop();
    changingPart.style.opacity = 0;
    setTimeout(function () {
      changingPart.textContent = nextText;
      changingPart.style.opacity = 1;
    }, 500);
  }

  setInterval(changeText, 3000);
}

var _default = changingText;
exports["default"] = _default;

},{}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function visitorGuide() {
  function directory() {
    var tabs = document.querySelectorAll('.directory-tab');
    var galleryWrapper = document.querySelector('.digital-directory .gallery-wrapper');
    tabs.forEach(function (tab) {
      var id = tab.dataset.id;
      var block = document.createElement('div');
      block.setAttribute('class', 'gallery-block');
      block.setAttribute('data-galleryID', id);
      var gallery = document.createElement('script');
      gallery.src = "https://starling.crowdriff.com/js/crowdriff.js";
      gallery.id = id;
      block.appendChild(gallery);
      galleryWrapper.appendChild(block);
    });
    var blocks = document.querySelectorAll('.gallery-block');
    blocks[0].classList.add('active');
    tabs[0].classList.add('active');
    window.addEventListener('click', function (e) {
      if (e.target.classList.contains('directory-tab') && !e.target.classList.contains('active')) {
        var allTabs = document.querySelectorAll('.directory-tab');
        allTabs.forEach(function (tab) {
          tab.classList.remove('active');
        });
        var allBlocks = document.querySelectorAll('.gallery-block');
        allBlocks.forEach(function (block) {
          block.classList.remove('active');
        });
        var id = e.target.dataset.id;
        e.target.classList.add('active');
        var currentBlock = document.querySelector(".gallery-block[data-galleryID='".concat(id, "']"));
        currentBlock.classList.add('active');
      }
    });
  }

  ;
  directory();

  function stickyNav() {
    var menuHeight = $('.guide-menu').height();
    $('.guide-menu').css('height', menuHeight);
    $(window).on('scroll', function () {
      var top = $(window).scrollTop();
      var menu = $('.guide-menu');
      var menuTop = $('.guide-menu').offset().top;
      var demoTop = $('.demo-banner').offset().top - 50;

      if (top >= menuTop) {
        menu.addClass('sticky');
      } else {
        menu.removeClass('sticky');
      }

      if (top >= demoTop) {
        menu.addClass('hide');
      } else {
        menu.removeClass('hide');
      }
    });
  }

  stickyNav();

  function mobileNav() {
    $('.mobile-label').click(function () {
      $('.guide-menu ul').toggleClass('open');
    });
    var items = document.querySelectorAll('.is-menu-item');
    window.addEventListener('scroll', function () {
      items.forEach(function (item) {
        var y = window.scrollY;
        var top = item.offsetTop - 100;
        var height = item.offsetHeight;
        var bottom = top + height;
        var labelWrapper = document.querySelector('.mobile-label');
        var label = item.dataset.label;

        if (y >= top && y <= bottom) {
          labelWrapper.innerHTML = label;
        }
      });
    });
    $('.guide-menu a').click(function (e) {
      $('.guide-menu ul').removeClass('open');
      var label = this.innerHTML;
      var labelWrapper = document.querySelector('.mobile-label');
      labelWrapper.innerHTML = label;
    });
  }

  mobileNav();

  function modal() {
    var triggers = document.querySelectorAll('.modal-trigger');
    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var modal = document.querySelector("#".concat(trigger.dataset.id));
        modal.classList.add('active');
      });
    });
    var modals = document.querySelectorAll('.guide-modal');
    modals.forEach(function (modal) {
      window.addEventListener('click', function (e) {
        if (e.target.classList.contains('guide-modal') || e.target.closest('button') != null && e.target.closest('button').classList.contains('close-modal')) {
          modal.classList.remove('active');
        }
      });
    });
    var tabs = document.querySelectorAll('.modal-wrapper .tab');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var closeTabs = tab.closest('.guide-modal').querySelectorAll('.tab');
        closeTabs.forEach(function (closeTab) {
          closeTab.classList.remove('active');
        });
        var closeContent = tab.closest('.guide-modal').querySelectorAll('.modal-tab-content');
        closeContent.forEach(function (closeContent) {
          closeContent.classList.remove('active');
        });
        tab.classList.add('active');
        var content = document.querySelector(".modal-tab-content[data-tab=\"".concat(tab.dataset.tab, "\"]"));
        content.classList.add('active');
      });
    });
    var htmlBlocks = document.querySelectorAll('code.language-markup');
    htmlBlocks.forEach(function (block) {
      var htmlEncoded = block.innerHTML.replace(/</g, '&lt;');
      block.innerHTML = htmlEncoded;
    });

    var copyToClipboard = function copyToClipboard(str) {
      var el = document.createElement('textarea');
      el.value = str;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
    };

    var copyButtons = document.querySelectorAll('button.copy-content');
    copyButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var content = btn.closest('.modal-tab-content').querySelector('code').innerHTML.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&');
        copyToClipboard(content);
        var label = btn.querySelector('.copy-label');
        label.classList.add('active');
        setTimeout(function () {
          label.classList.remove('active');
        }, 2000);
      });
    });
  }

  modal();
}

function visitorGuideInit() {
  if ($('main.visitor-guide').length) {
    visitorGuide();
  }
}

var _default = visitorGuideInit;
exports["default"] = _default;

},{}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var renderIframe = function renderIframe(src, title, place) {
  var iframe = "<div class=\"iframe-wrapper\"><iframe src=\"".concat(src, "\" title=\"").concat(title, "\" allowtransparency=\"true\" frameborder=\"0\" scrolling=\"no\" name=\"wistia_embed\" allowfullscreen=\"\" mozallowfullscreen=\"\" webkitallowfullscreen=\"\" oallowfullscreen=\"\" msallowfullscreen=\"\" width=\"530\" height=\"298\" allow=\"fullscreen\"></iframe></div>");
  place.html(iframe);
  $('html, body').animate({
    scrollTop: place.offset().top - 100
  }, 800);
};

function addDownloadPdfButton(url, place) {
  var addPdfInterval = setInterval(function () {
    if ($('.submitted-message').length) {
      place.append("<a id=\"download-ebook\" class=\"btn btn-blue\" href=\"".concat(url, "\" target=\"_blank\" rel=\"noopener noreferrer\">Download</a>"));
      clearInterval(addPdfInterval);
    }
  }, 100);
}

var initEbooks = function initEbooks() {
  var wrapper = $('.ebook__gated-wrapper');

  if (wrapper.length) {
    // const formRendered = setInterval(() => {
    window.addEventListener('message', function (event) {
      if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmit') {
        var pdfWrapper = wrapper.find('.ebook-pdf');
        var pdfUrl = pdfWrapper.attr('data-pdf');
        var iframWrapper = wrapper.find('.webinar-iframe');
        var iframeUrl = iframWrapper.attr('data-iframe');

        if (pdfUrl) {
          addDownloadPdfButton(pdfUrl, $('.ebook-form__form'));
          window.open(pdfUrl, '_blank', 'noopener, noreferrer');
        } else if (iframeUrl) {
          var title = $('.resources-single .entry-title').text();
          renderIframe(iframeUrl, title, iframWrapper);
          $('.ebook-form').remove();
        }
      }
    });
  }
};

var _default = initEbooks;
exports["default"] = _default;

},{}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function footerInit() {
  var demoBanner = document.getElementById('demo-banner');

  if (!demoBanner) {
    // no demo banner, add link to watch a preview demo
    var headerCta = document.getElementById('header-demo');
    var footerCta = document.getElementById('footer-demo');
    headerCta.href = 'https://go.crowdriff.com/request-a-crowdriff-demo-ugc-and-visual-marketing';
    footerCta.href = 'https://go.crowdriff.com/request-a-crowdriff-demo-ugc-and-visual-marketing';
  }
}

var _default = footerInit;
exports["default"] = _default;

},{}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function homeIndustries() {
  var industryCard = $('.home-industries .card');
  var industrySlider = $('.industry-slider');

  function imgRollover() {
    var preloadImgs = [];

    for (var i = 0; i < industryCard.length; i++) {
      preloadImgs.push(new Image());
      preloadImgs[preloadImgs.length - 1].src = industryCard[i].getAttribute('data-image');

      industryCard[i].onmouseover = function () {
        this.src = this.getAttribute('data-image');
        var imgURL = 'url("' + this.src + '")';
        $('.industry-image').css('background-image', imgURL);
      };
    }
  }

  function imgChangeMobile() {
    var preloadImgs = [];

    for (var i = 0; i < industryCard.length; i++) {
      preloadImgs.push(new Image());
      preloadImgs[preloadImgs.length - 1].src = industryCard[i].getAttribute('data-image');
      industrySlider.on('afterChange', function () {
        var sliderImgData = $('.slick-active .card').data('image');
        var sliderImgURL = 'url("' + sliderImgData + '")';
        $('.industry-image').css('background-image', sliderImgURL);
      });
    }
  }

  $(window).scroll(function () {
    var hT = $('.home-industries').offset().top,
        hH = $('.home-industries').outerHeight(),
        wH = $(window).height(),
        wS = $(this).scrollTop() + 1000;

    if (wS > hT + hH - wH) {
      imgRollover();
      imgChangeMobile();
    }
  });
  $(window).on('resize', function () {
    if ($(window).width() > 1200) {
      industryCard.appendTo('.home-industries .container');
      industrySlider.empty().removeClass('slick-initialized slick-slider');

      if (industryCard.hasClass('slick-initialized')) {
        industrySlider.slick('unslick');
      }
    } else {
      // Mobile Slider
      if (!$('.industry-slider').length) {
        $('.home-industries .container').append('<div class="industry-slider"></div>');
      }

      if (!$('.industry-slider .card').length) {
        industryCard.appendTo(industrySlider);
      }

      if (!industryCard.hasClass('slick-initialized')) {
        industrySlider.slick({
          slidesToShow: 1,
          arrows: false,
          dots: true
        });
      }
    }
  }).resize();
}

function homeIndustriesInit() {
  if ($('.home-industries').length) {
    homeIndustries();
  }
}

var _default = homeIndustriesInit;
exports["default"] = _default;

},{}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var hubspotInit = function hubspotInit() {
  $(".gated-form--email").click(function () {
    $(this).closest(".gated-form").addClass("gated-form--hidden");
    $(this).closest(".hubspot-wrapper").find(".hubspot-form > .hs-form .input input").first().focus();
  });
  $(".gated-deactivate-button").click(function () {
    $(this).closest(".hubspot-wrapper").find(".gated-form").removeClass("gated-form--hidden");
  });
};

document.addEventListener("DOMContentLoaded", function () {
  // Define your UTM parameters here
  var utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
  var urlParams = new URLSearchParams(window.location.search);
  utmParams.forEach(function (param) {
    var inputField = document.querySelector("input[name=\"".concat(param, "\"]"));

    if (inputField) {
      // Set the field value based on the URL parameter, or leave it empty
      inputField.value = urlParams.get(param) || '';
    }
  });
});
var _default = hubspotInit;
exports["default"] = _default;

},{}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function mapbox() {
  mapboxgl.accessToken = 'pk.eyJ1IjoiY2pyZXllcyIsImEiOiJjazZqZWFkeHEwYXVyM2xuOHdkaWllZmN2In0.K3-i5xBpP-19eoH_vGjMiQ';
  var map = new mapboxgl.Map({
    container: 'contact-map',
    style: 'mapbox://styles/mapbox/light-v10',
    center: [-79.38888873236945, 43.64986156978978],
    zoom: 15
  });
  $(window).bind('mousewheel DOMMouseScroll', function (event) {
    if (event.ctrlKey == true) {
      map['scrollZoom'].enable();
    } else {
      map['scrollZoom'].disable();
    }
  });
  var geojson = {
    type: 'FeatureCollection',
    features: [{
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-79.38888873236945, 43.64986156978978]
      },
      properties: {
        title: 'CrowdRiff',
        description: '240 Richmond St. W. <br>5th floor, Unit 5-101 <br> Toronto, ON M5V 1V6'
      }
    }]
  };
  geojson.features.forEach(function (marker) {
    // create a HTML element for each feature
    var el = document.createElement('div');
    el.className = 'marker'; // make a marker for each feature and add to the map

    new mapboxgl.Marker(el).setLngLat(marker.geometry.coordinates).setPopup(new mapboxgl.Popup({
      offset: -80
    }) // add popups
    .setHTML('<h3>' + marker.properties.title + '</h3><p>' + marker.properties.description + '</p>')).addTo(map);
  });
}

function mapboxInit() {
  if ($('#contact-map').length) {
    mapbox();
  }
}

var _default = mapboxInit;
exports["default"] = _default;

},{}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var navApp = {};
var hasNav = $('.has-mega-nav');
var navTrigger = $('.mega-nav--trigger');
var megaNav = $('.mega-nav');

function navAppInit() {
  navApp.bgType();
  navApp.hasHelloBar();
  navApp.trigger();
  navApp.bodyClick();
  navApp.mobileSetup();
  navApp.mobileMenuTrigger();
  navApp.scroll();
}

navApp.bgType = function () {
  if ($('section').hasClass('enterprise-banner') || $('section').hasClass('transparent-header')) {
    $('body').addClass('transparent-header');
  }

  if ($('section').hasClass('banner-blue')) {
    $('body').addClass('grey-header');
  }

  if ($('div').hasClass('hello-bar')) {
    $('body').addClass('has-hello-bar');
  }
};

navApp.trigger = function () {
  navTrigger.on('mouseover', function (e) {
    e.preventDefault();

    if ($('body').hasClass('mobile')) {
      if ($(this).parent().hasClass('nav-open')) {
        hasNav.removeClass('nav-open');
        megaNav.removeClass('open');
      } else {
        hasNav.removeClass('nav-open');
        megaNav.removeClass('open');
        $(this).parent().addClass('nav-open');
        $(this).parent().find(megaNav).addClass('open');
      }
    } else {
      // Mega nav dropdown
      if ($(this).parent().hasClass('nav-open')) {
        hasNav.removeClass('nav-open');
        megaNav.slideUp();
        $('nav.main-nav').removeClass('inner-nav-open');
      } else if (!$('.has-mega-nav').hasClass('nav-open')) {
        hasNav.removeClass('nav-open');
        megaNav.slideUp();
        $(this).parent().addClass('nav-open');
        $(this).parent().find(megaNav).slideDown();
        $('nav.main-nav').addClass('inner-nav-open');
      } else {
        hasNav.removeClass('nav-open');
        megaNav.css('display', 'none');
        $(this).parent().addClass('nav-open');
        $(this).parent().find(megaNav).css('display', 'block');
      } // Mega nav heading height


      var megaHeader = $('.mega-nav--main h2').parent().parent();
      megaHeader.each(function (i) {
        var itemHeight = $(this).next().next().height();
        $(this).css('height', itemHeight);
      });
    }
  }); // On mobile, return to main menu when trigger on submenu is clicked

  $('.mega-nav--main').on('click', '.main-menu-trigger', function (e) {
    e.preventDefault();
    hasNav.removeClass('nav-open');
    megaNav.removeClass('open');
  });
};

navApp.bodyClick = function () {
  var clickTarget = $('.has-mega-nav');
  $('body').mouseup(function (e) {
    if (e.target.id != clickTarget.attr('id') && !clickTarget.has(e.target).length) {
      hasNav.removeClass('nav-open');
      megaNav.slideUp();
      $('nav.main-nav').removeClass('inner-nav-open');
    }
  });
};

navApp.hasHelloBar = function () {
  var barHeight = $('.hello-bar').height();
  $('nav.main-nav:not(.nav-scrolled):not(.nav-up)').css('top', barHeight);
};

navApp.scroll = function () {
  var didScroll;
  var lastScrollTop = 0;
  var delta = 5;
  var navbarHeight = $('nav').outerHeight(); // On scroll, let the interval function know the user has scrolled

  $(window).scroll(function (event) {
    didScroll = true;
  }); // Run hasScrolled() and reset didScroll status

  setInterval(function () {
    if (didScroll) {
      hasScrolled();
      addBoxShadow();
      didScroll = false;
    }
  }, 0);

  function hasScrolled() {
    var st = $(window).scrollTop();
    if (Math.abs(lastScrollTop - st) <= delta) return; // If current position > last position AND scrolled past navbar...

    if (st > lastScrollTop && st > navbarHeight && !$('.nav-center').hasClass('mobile-menu-open')) {
      // Scroll down
      $('nav').removeClass('nav-down inner-nav-open').addClass('nav-up');
      hasNav.removeClass('nav-open');
      megaNav.slideUp(250);
    } else {
      // Scroll up
      if (st + $(window).height() < $(document).height()) {
        $('nav').removeClass('nav-up').addClass('nav-down');
      }
    }

    lastScrollTop = st;
  }

  function addBoxShadow() {
    var y = $(document).scrollTop();
    var barHeight = $('.hello-bar').height();
    var hasHelloBar = barHeight !== undefined;

    if (hasHelloBar) {
      if (y > barHeight) {
        $('nav.main-nav').addClass('nav-scrolled');
        $('nav.main-nav').css('top', '40px');
        $('nav.main-nav.nav-up').css('top', '-88px');
      } else {
        $('nav.main-nav').removeClass('nav-scrolled');
        $('nav.main-nav').css('top', barHeight);
      }
    } else {
      if (y > 0) {
        $('nav.main-nav').addClass('nav-scrolled');
      } else {
        $('nav.main-nav').removeClass('nav-scrolled');
      }
    }
  }
};

navApp.mobileSetup = function () {
  $(window).on('resize', function () {
    if ($('body').hasClass('mobile')) {
      $('.nav-right ul li').appendTo('#mobile-buttons');
    } else {// $('.trigger-login').appendTo('.nav-right ul');
      // $('.trigger-demo').appendTo('.nav-right ul');
    }
  }).resize();
};

navApp.mobileMenuTrigger = function () {
  var mobileTrigger = $('button.mobile-menu-trigger');
  mobileTrigger.on('click', function () {
    $('.nav-center').toggleClass('mobile-menu-open');
    $(this).toggleClass('open');
    megaNav.removeClass('open');
    hasNav.removeClass('nav-open');

    if (mobileTrigger.attr('aria-expanded')) {
      mobileTrigger.removeAttr('aria-expanded');
      $('.hello-bar').show();
      var barHeight = $('.hello-bar').height();
      $('nav.main-nav:not(.nav-scrolled):not(.nav-up)').css('top', barHeight);
    } else {
      mobileTrigger.attr('aria-expanded', true);
      $('.hello-bar').hide();
      $('nav.main-nav:not(.nav-scrolled):not(.nav-up)').css('top', 0);
    }
  });
};

var _default = navAppInit;
exports["default"] = _default;

},{}],12:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var initProgressBar = function initProgressBar() {
  var body = document.querySelector('body');

  if (body.classList.contains('single-resources')) {
    body.insertAdjacentHTML('afterbegin', '<div class="progressBar"></div>');
    var progressBar = document.querySelector('.progressBar');
    var section = body;
    var footer = document.querySelector('footer .container');

    var scrollProgressBar = function scrollProgressBar() {
      var scrollDistance = -section.getBoundingClientRect().top;
      var progressPercentage = scrollDistance / (section.getBoundingClientRect().height - document.documentElement.clientHeight - footer.offsetHeight) * 100;
      var val = Math.floor(progressPercentage);
      progressBar.style.width = val + '%';

      if (val < 0) {
        progressBar.style.width = '0%';
      }
    };

    window.addEventListener('scroll', scrollProgressBar);
  }
};

var _default = initProgressBar;
exports["default"] = _default;

},{}],13:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var resourcesFilterSearchInit = function resourcesFilterSearchInit() {
  var resourcesBar = $('.resources-bar');

  if (resourcesBar.length) {
    var buttons = resourcesBar.find('.resources-bar__filter button');
    buttons.on('click', function () {
      var aExpanded = 'true';

      if ($(this).attr('aria-expanded') === 'true') {
        aExpanded = 'false';
      }

      buttons.attr('aria-expanded', 'false');
      $(this).attr('aria-expanded', aExpanded);
    });
    var links = resourcesBar.find('.resources-bar__filter a');
    links.on('keydown', function (event) {
      if (event.keyCode === 27) {
        event.preventDefault();
        buttons.attr('aria-expanded', 'false');
        $(this).parent().parent().parent().find('button').focus();
      }
    });
    $(document).click(function (event) {
      var $target = $(event.target);

      if (!$target.closest('.resources-bar__filter').length) {
        buttons.attr('aria-expanded', 'false');
      }
    });
  }

  var resourceSearch = $('.resources-bar__search');

  if (resourceSearch.length) {
    var searchRenderList = function searchRenderList(arr) {
      if ($('.resources-bar__search-recent').length === 0) {
        var html = "<aside class='resources-bar__search-recent' role='dialog'>\n\t\t\t<h2 class='resources-bar__search-recent-header'>Recent searches</h2>\n\t\t\t<ul class='resources-bar__search-recent-list'>";
        arr.forEach(function (key) {
          html += "\n\t\t\t\t\t<li>\n\t\t\t\t\t\t<button\n\t\t\t\t\t\t\tclass='resources-bar__search-recent-button'\n\t\t\t\t\t\t\taria-label='Search for: ".concat(key, "'\n\t\t\t\t\t\t\ttype='button'\n\t\t\t\t\t\t>\n\t\t\t\t\t\t\t<i class='fas fa-search' aria-hidden='true'></i>\n\t\t\t\t\t\t\t<span class='resources-bar__search-recent-query'>").concat(key, "</span>\n\t\t\t\t\t\t</button>\n\t\t\t\t\t</li>");
        });
        html += "</ul>\n\t\t\t</aside>";
        return html;
      }
    };

    var savedRecentItems = sessionStorage.getItem('resourcesSearchRecentItems');
    var recentItems = [];

    if (savedRecentItems && JSON.parse(savedRecentItems).length) {
      recentItems = _toConsumableArray(JSON.parse(savedRecentItems));
      var form = $('.resources-bar__search-form');
      form.on('focusin', function () {
        setTimeout(function () {
          resourceSearch.append(searchRenderList(recentItems));
          $('.resources-bar__search-recent-button').click(function () {
            var key = $(this).find('.resources-bar__search-recent-query').text();
            $('#key').val(key);
            $('.resources-bar__search-recent').remove();
            form.submit();
          });
        }, 500);
      });
      $(document).on('click focusin', function (event) {
        var $target = $(event.target);

        if (!$target.closest('.resources-bar__search').length && $('.resources-bar__search-recent').is(':visible')) {
          $('.resources-bar__search-recent').remove();
        }
      });
    }

    $('#searchopen').click(function (event) {
      event.preventDefault();
      $('.resources-bar__search').addClass('active');
      setTimeout(function () {
        $('#key').focus();
        $('.resources-bar__search').addClass('opened');
      }, 400);
    });
    $('#searchclose').click(function (event) {
      event.preventDefault();
      $('.resources-bar__search').removeClass('active opened');
    });
    $('.resources-bar__search-form').on('submit', function () {
      var query = $('#key').val();

      if (!recentItems.includes(query) && query !== '') {
        recentItems.push(query);
        sessionStorage.setItem('resourcesSearchRecentItems', JSON.stringify(recentItems));
      }

      return true;
    });
  }
};

var _default = resourcesFilterSearchInit;
exports["default"] = _default;

},{}],14:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function scrollEvents() {
  document.addEventListener('lazybeforeunveil', function (event) {
    ScrollReveal().reveal('.insta-slide-up', {
      delay: 400,
      distance: '50px',
      origin: 'bottom',
      duration: 500,
      easing: 'ease',
      interval: 150
    });
    ScrollReveal().reveal('.insta-slide-down', {
      delay: 400,
      distance: '50px',
      origin: 'top',
      duration: 500,
      easing: 'ease',
      interval: 150
    });
  });

  if ($('body').hasClass('mobile')) {
    ScrollReveal().reveal('.fade-in', {
      delay: 100,
      duration: 500,
      easing: 'ease',
      interval: 100
    });
    ScrollReveal().reveal('.fade-in-delayed', {
      delay: 800,
      duration: 2000,
      easing: 'ease',
      interval: 150
    });
    ScrollReveal().reveal('.slide-in', {
      delay: 100,
      distance: '40px',
      origin: 'bottom',
      duration: 800,
      easing: 'ease',
      interval: 100
    });
    ScrollReveal().reveal('.slide-in-right', {
      delay: 100,
      distance: '40px',
      origin: 'bottom',
      duration: 800,
      easing: 'ease',
      interval: 100
    });
  } else {
    ScrollReveal().reveal('.fade-in', {
      delay: 200,
      duration: 500,
      easing: 'ease',
      interval: 150
    });
    ScrollReveal().reveal('.fade-in-delayed', {
      delay: 800,
      duration: 2000,
      easing: 'ease',
      interval: 150
    });
    ScrollReveal().reveal('.slide-in', {
      delay: 300,
      distance: '70px',
      origin: 'bottom',
      duration: 800,
      easing: 'ease',
      interval: 150
    });
    ScrollReveal().reveal('.slide-in-right', {
      delay: 300,
      distance: '30px',
      origin: 'right',
      duration: 800,
      easing: 'ease',
      interval: 150
    });
  }

  function handleScroll(el) {
    $(window).scroll(function () {
      var hT = $(el).offset().top,
          hH = $(el).outerHeight(),
          wH = $(window).height(),
          wS = $(this).scrollTop() - 100;

      if (wS > hT + hH - wH) {
        $(el).addClass('reveal');
      }
    });
  }

  function targetScroll(el) {
    $(el).each(function (i) {
      $(this).attr('id', 'scroll' + [i + 1]);
      var scrollEl = '#' + $(this).attr('id');
      handleScroll(scrollEl);
    });
  }

  targetScroll('.highlight');
  document.addEventListener('lazybeforeunveil', function (e) {
    var bg = e.target.getAttribute('data-bg');

    if (bg) {
      e.target.style.backgroundImage = 'url(' + bg + ')';
    }
  });

  if (document.querySelector('.gallery-api')) {
    gsap.to(".gallery-api .container", {
      scrollTrigger: {
        trigger: ".gallery-api .container",
        scrub: true
      },
      x: -200
    });
  }

  if (document.querySelector('.media-content.share')) {
    ScrollTrigger.matchMedia({
      "(min-width: 768px)": function minWidth768px() {
        gsap.to(".media-content.share .platform", {
          scrollTrigger: {
            trigger: ".media-content.share",
            scrub: true,
            start: 'top 50%'
          },
          y: -100
        });
      },
      "(max-width: 767px)": function maxWidth767px() {
        gsap.to(".media-content.share .platform", {
          scrollTrigger: {
            trigger: ".media-content.share",
            scrub: true,
            start: 'top 50%'
          },
          y: -50
        });
      }
    });
  }

  if (document.querySelector('.media-content.coordinate')) {
    ScrollTrigger.matchMedia({
      "(min-width: 768px)": function minWidth768px() {
        gsap.to(".media-content.coordinate .overlay", {
          scrollTrigger: {
            trigger: ".media-content.coordinate",
            scrub: true,
            start: 'top 50%'
          },
          y: -100
        });
      },
      "(max-width: 767px)": function maxWidth767px() {
        gsap.to(".media-content.coordinate .overlay", {
          scrollTrigger: {
            trigger: ".media-content.coordinate",
            scrub: true,
            start: 'top 50%'
          },
          y: -50
        });
      }
    });
  }

  if (document.querySelector('.media-content.connect')) {
    ScrollTrigger.matchMedia({
      "(min-width: 768px)": function minWidth768px() {
        gsap.to(".media-content.connect .approval", {
          scrollTrigger: {
            trigger: ".media-content.connect",
            scrub: true,
            start: 'top 50%'
          },
          y: -50
        }), gsap.to(".media-content.connect .comment", {
          scrollTrigger: {
            trigger: ".media-content.connect",
            scrub: true,
            start: 'top 50%'
          },
          y: -100
        });
      },
      "(max-width: 767px)": function maxWidth767px() {
        gsap.to(".media-content.connect .approval", {
          scrollTrigger: {
            trigger: ".media-content.connect",
            scrub: true,
            start: 'top 50%'
          },
          y: -20
        }), gsap.to(".media-content.connect .comment", {
          scrollTrigger: {
            trigger: ".media-content.connect",
            scrub: true,
            start: 'top 50%'
          },
          y: -50
        });
      }
    });
  }
}

var _default = scrollEvents;
exports["default"] = _default;

},{}],15:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function seeConference() {
  //Nav
  $('button.mobile-trigger').click(function () {
    $(this).toggleClass('open');
    $('nav').toggleClass('open');
  });
  $('#landing-register').click(function (e) {
    $('button.mobile-trigger').removeClass('open');
    $('nav').removeClass('open');
  }); //Slick Slider

  $('.hotel-slider').slick({
    arrows: false,
    dots: false,
    adaptiveHeight: true,
    fade: true,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: false
  });
  $('.keynote-speakers-slider').slick({
    arrows: true,
    prevArrow: '<a class="slick-prev slick-arrow"><i class="fa fa-angle-left"></i></a>',
    nextArrow: '<a class="slick-next slick-arrow"><i class="fa fa-angle-right"></i></a>',
    dots: false,
    fade: true,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true
  });
  $('.quotes-wrapper').slick({
    arrows: false,
    dots: true,
    fade: true,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true
  }); //Scroll Reveal

  ScrollReveal().reveal('.speaker-grid-item.item-1', {
    delay: 800,
    distance: '80px',
    origin: 'bottom',
    duration: 800,
    easing: 'ease'
  });
  ScrollReveal().reveal('.see__about .content-right', {
    delay: 100,
    distance: '80px',
    origin: 'bottom',
    duration: 800,
    easing: 'ease'
  });
  ScrollReveal().reveal('.see__about .content-right img', {
    delay: 1000,
    distance: '50px',
    origin: 'bottom',
    duration: 800,
    easing: 'ease',
    interval: 200
  });
  ScrollReveal().reveal('.see__social-share .container', {
    delay: 800,
    distance: '80px',
    origin: 'bottom',
    duration: 800,
    easing: 'ease'
  });
  ScrollReveal().reveal('.see__giveaway .banner-content', {
    delay: 800,
    distance: '80px',
    origin: 'bottom',
    duration: 800,
    easing: 'ease'
  });

  function seeHandleScroll(el) {
    $(window).scroll(function () {
      var hT = $(el).offset().top,
          hH = $(el).outerHeight(),
          wH = $(window).height(),
          wS = $(this).scrollTop() - 100;
      padding = $(el).data('padding');
      elWidth = $(el).find('span.text-width').width() + (padding / 2 - 10);

      if (wS > hT + hH - wH) {
        $(el).css('width', elWidth);
        $(el).css('padding-left', padding);
        $(el).css('padding-right', padding);
      }
    });
  }

  function seeTargetScroll(el) {
    $(el).each(function (i) {
      $(this).attr('id', 'scroll' + [i + 1]);
      var scrollEl = '#' + $(this).attr('id');
      seeHandleScroll(scrollEl);
    });
  }

  seeTargetScroll('.animateScroll');
  $('.resource-block').on('mouseenter', function () {
    $('.resource-block').not(this).addClass('fade');
    $(this).addClass('active');
  });
  $('.resource-block').on('mouseleave', function () {
    $('.resource-block').removeClass('fade');
    $(this).removeClass('active');
  });
  $('form#see-password').css('opacity', 1);
  $('form#see-password-2020').css('opacity', 1);
  $(document).on('submit', 'form#see-password', function (e) {
    e.preventDefault();
    var passwordVal = $('#see-password input[type="password"]').val();

    if (passwordVal == 'SEE2019') {
      $('.see-resources-password').remove();
      $('.resources-section').css('display', 'block');
      localStorage.setItem('resources', 'correct');
    } else {
      $('#see-password .error').css('display', 'block');
    }
  });
  $(document).on('submit', 'form#see-password-2020', function (e) {
    e.preventDefault();
    var passwordVal = $('#see-password-2020 input[type="password"]').val();

    if (passwordVal == 'SEE2020' || passwordVal == 'SEE2022' || passwordVal == 'SEE2023') {
      $('.see-resources-password').remove();
      $('.resources-section').css('display', 'block');
      localStorage.setItem('resources', 'correct');
    } else {
      $('#see-password-2020 .error').css('display', 'block');
    }
  });
  var passwordStatus = localStorage.getItem('resources');

  if (passwordStatus == 'correct') {
    $('.see-resources-password').remove();
    $('.resources-section').css('display', 'block');
  } // SEE 2020 Agenda


  $('button.item-wrapper').click(function () {
    $(this).toggleClass('open');
    $(this).find('.item-description').slideToggle();
  }); // SEE 2020 Speakers

  $(window).on('load', function () {
    var hash = window.location.hash;

    if (hash) {
      var newHash = hash.replace('#', '');
      var directPopup = document.querySelector(".speaker-popup[data-id=".concat(newHash));
      directPopup.classList.add('active');
    }
  });
  $('button.speaker-trigger').click(function () {
    $(this).parent().find('.speaker-popup').addClass('active');
  });
  $('button.close-speaker-popup').click(function () {
    $(this).parent().parent().removeClass('active');
  });
  var clickTarget = $('.speaker-popup');
  $('body').mouseup(function (e) {
    if (e.target.id != clickTarget.attr('id') && !clickTarget.has(e.target).length) {
      $('.speaker-popup').removeClass('active');
    }
  });
  var popupSliders = document.querySelectorAll('.popup-images');
  popupSliders.forEach(function (slider) {
    $(slider).slick({
      arrows: false,
      dots: true,
      fade: true,
      autoplay: true,
      autoplaySpeed: 5000
    });
  }); // Landing page animation
  // if ($('#animated-logo').length){
  // 	var logoAnimation = bodymovin.loadAnimation({
  // 		container: document.getElementById('animated-logo'),
  // 		renderer: 'svg',
  // 		loop: false,
  // 		autoplay: false,
  // 		path: 'https://cdn2.hubspot.net/hubfs/2719325/SEE%202019%20CrowdRiff%20Conference/splash-page/LandingLogo-white.json'
  // 		})
  // 		// var angleAnimation = bodymovin.loadAnimation({
  // 		// container: document.getElementById('animated-angles'),
  // 		// renderer: 'svg',
  // 		// loop: false,
  // 		// autoplay: false,
  // 		// path: 'https://cdn2.hubspot.net/hubfs/2719325/SEE%202019%20CrowdRiff%20Conference/splash-page/LandingAngles-TopLeft_NoText.json'
  // 		// })
  // function seeFadeIn(){
  // $('.see-fade-in').addClass('show');
  // }
  // setTimeout(function(){
  // // logoAnimation.play();
  // // angleAnimation.play();
  // seeFadeIn();
  // }, 1000);
  // }
}

function seeConference2019() {
  if ($('body#see-page').length) {
    seeConference();
  }
}

var _default = seeConference2019;
exports["default"] = _default;

},{}],16:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var seeMoreResourcesInit = function seeMoreResourcesInit() {
  var resourcesMain = $('.resources-main');

  var seeMoreResources = function seeMoreResources(event) {
    var _seeMoreBtn$attr, _seeMoreBtn$attr2, _seeMoreBtn$attr3, _seeMoreBtn$attr4, _seeMoreBtn$attr5;

    var seeMoreBtn = $(event.target);
    var taxonomy = seeMoreBtn.attr('data-taxonomy');
    var termId = seeMoreBtn.attr('data-term');
    var pagination = (_seeMoreBtn$attr = seeMoreBtn.attr('data-page')) !== null && _seeMoreBtn$attr !== void 0 ? _seeMoreBtn$attr : 1;
    var offset = (_seeMoreBtn$attr2 = seeMoreBtn.attr('data-offset')) !== null && _seeMoreBtn$attr2 !== void 0 ? _seeMoreBtn$attr2 : '';
    var boxesOrder = (_seeMoreBtn$attr3 = seeMoreBtn.attr('data-boxes-order')) !== null && _seeMoreBtn$attr3 !== void 0 ? _seeMoreBtn$attr3 : '';
    var boxesOrderCurrent = (_seeMoreBtn$attr4 = seeMoreBtn.attr('data-boxes-order-current')) !== null && _seeMoreBtn$attr4 !== void 0 ? _seeMoreBtn$attr4 : '';
    var key = (_seeMoreBtn$attr5 = seeMoreBtn.attr('data-key')) !== null && _seeMoreBtn$attr5 !== void 0 ? _seeMoreBtn$attr5 : '';
    var is_search = seeMoreBtn.hasClass('see-more-search');
    var loading = "<li class=\"resources-grid__item\">\n                            <span class=\"resources-grid__item-link resources-grid__item-link-spinner\">\n                                <span role=\"presentation\" class=\"spinner\"></span>\n                                <span role=\"alert\" class=\"spinner-text\">Loading more<span aria-hidden=\"true\">...</span></span>\n                            </span>\n                        </li>";
    seeMoreBtn.animate({
      top: '200px',
      opacity: '0'
    }, 200, function () {
      seeMoreBtn.remove();

      if (is_search) {
        $(".resources-grid__".concat(termId)).append(loading);
      } else {
        $('.resources-grid').append(loading);
      }
    });
    $.ajax({
      async: true,
      url: '/wp-json/crowdriff-resources/see-more-resources',
      type: 'POST',
      dataType: 'json',
      data: {
        taxonomy: taxonomy,
        term_id: termId,
        pagination: pagination,
        offset: offset,
        boxes_order: boxesOrder,
        boxes_order_current: boxesOrderCurrent,
        key: key
      },
      success: function success(result) {
        if (result.body_response[0]) {
          if (is_search) {
            $(".resources-grid__".concat(termId)).append(result.body_response[0]);
          } else {
            $('.resources-grid').append(result.body_response[0]);
          }

          setTimeout(function () {
            $('.resources-grid__item-link-spinner').parent().next().find('a').focus();
            $('.resources-grid__item-link-spinner').parent().remove();
            var divs = $('.resources-grid__item-animate-in');
            var index = 0;
            var delay = setInterval(function () {
              if (index <= divs.length) {
                $(divs[index]).addClass('animated');
                index += 1;
              } else {
                clearInterval(delay);
                divs.removeClass('resources-grid__item-animate-in animated');
              }
            }, 100);
          }, 20);

          if (result.body_response[1]) {
            var newButton = seeMoreBtn.attr('data-page', parseInt(pagination) + 1);
            newButton.click(seeMoreResources);

            if (is_search) {
              $(".resources-grid__".concat(termId)).parent().find('.see-more__container').append(newButton);
            } else {
              resourcesMain.find('.see-more__container').append(newButton);
            }

            newButton.animate({
              top: '0',
              opacity: '1'
            }, 200);
          }
        } else {
          $('.resources-grid__item-link-spinner').parent().remove();
        }
      }
    });
  };

  if (resourcesMain.length) {
    var seeMoreBtn = resourcesMain.find('button.see-more');

    if (seeMoreBtn) {
      seeMoreBtn.click(seeMoreResources);
    }
  }
};

var _default = seeMoreResourcesInit;
exports["default"] = _default;

},{}],17:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var singleResourcesInit = function singleResourcesInit() {
  if (document.querySelector('body').classList.contains('single-resources')) {
    // Add target blank to external links
    var addTargetBlank = function addTargetBlank() {
      var links = document.querySelectorAll('.single-resources a');
      links.forEach(function (link) {
        var href = link.getAttribute('href');

        if (href.indexOf(document.domain) == -1) {
          link.setAttribute('target', '_blank');
          link.setAttribute('rel', 'noreferrer noopener');
        }
      });
    };

    addTargetBlank(); // Add class to first image

    var addClassToFirstImage = function addClassToFirstImage() {
      var firstImage = document.querySelector('.single-resources .entry-content img');

      if (firstImage) {
        firstImage.classList.add('first-image');
      }
    };

    addClassToFirstImage(); // Swiper

    new Swiper('.single-resources__swiper', {
      slidesPerView: 1.3,
      spaceBetween: 20,
      navigation: {
        prevEl: '.swiper-button-prev',
        nextEl: '.swiper-button-next'
      },
      breakpoints: {
        575: {
          slidesPerView: 2.2
        },
        992: {
          slidesPerView: 3.2
        }
      }
    });
  }
};

var _default = singleResourcesInit;
exports["default"] = _default;

},{}],18:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function smoothScroll() {
  $('a[href*="#"]:not([href="#"])').click(function () {
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

      if (target.length) {
        var padding = $('main').hasClass('see2020') ? 0 : 80;
        $('html, body').animate({
          scrollTop: target.offset().top - padding
        }, 1000);
        return false;
      }
    }
  });
}

var _default = smoothScroll;
exports["default"] = _default;

},{}],19:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function tabbedContent() {
  $('ul.tabs li a').on('click', function (e) {
    e.preventDefault();
    var tab_id = $(this).parent().attr('data-tab');
    $('ul.tabs li').removeClass('current');
    $('.tab-content').css('display', 'none').removeClass('current');
    $(this).parent().addClass('current');
    $("#" + tab_id).addClass('current').css('display', 'block');
  });
}

function tabbedContentInit() {
  if ($('ul.tabs').length) {
    tabbedContent();
  }
}

var _default = tabbedContentInit;
exports["default"] = _default;

},{}],20:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function typingText() {
  new TypeIt('#type-industries', {
    strings: ["destination", "attraction", "resort", "hotel", "tour"],
    speed: 100,
    breakLines: false,
    waitUntilVisible: false,
    loop: true,
    deleteSpeed: 60,
    nextStringDelay: [3500, 500]
  }).go();
}

function typingTextInit() {
  if ($('#type-industries').length) {
    typingText();
  }
}

var _default = typingTextInit;
exports["default"] = _default;

},{}],21:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function windowSizeCheck() {
  $(window).on('resize', function () {
    if ($(window).width() <= 1024) {
      $('body').addClass('mobile');
    } else {
      $('body').removeClass('mobile');
    }
  }).resize();
}

var _default = windowSizeCheck;
exports["default"] = _default;

},{}],22:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function wistiaPopover() {
  $.fn.cssGet = function (propertyArray) {
    //create an output variable and limit this function to finding info for only the first element passed into the function
    var output = {},
        self = this.eq(0); //iterate through the properties passed into the function and add them to the output variable

    for (var i = 0, len = propertyArray.length; i < len; i++) {
      output[propertyArray[i]] = this.css(propertyArray[i]);
    }

    return output;
  };

  function makePopover(elem, mediaID) {
    $(elem).addClass("wistia_embed wistia_async_" + mediaID + " popover=true popoverContent=link");
    Wistia.embeds.setup();
    var popoverAction = {};

    popoverAction[mediaID] = function (video) {
      video.popover.show();
      video.play();
    };

    window._wq = window._wq || [];

    _wq.push(popoverAction);
  }

  $(".video-popup-wrapper").on("click", function (e) {
    e.preventDefault();
    var vidID = $(this).attr("data-video"); // if (!$(this).hasClass('relative')) {
    //     var vidBtn = $(this).find('a');
    //     var vidBtnCSS = vidBtn.cssGet(['position', 'top', 'left', 'height', 'width']);
    //     if (vidBtnCSS.position == 'absolute'){
    //         $(this).css('position', vidBtnCSS.position);
    //         $(this).css('top', vidBtnCSS.top);
    //         $(this).css('left', vidBtnCSS.left);
    //         $(this).css('height', vidBtnCSS.height);
    //         $(this).css('width', vidBtnCSS.width);
    //         $(vidBtn).css('position', 'relative');
    //         $(vidBtn).css('top', 0);
    //         $(vidBtn).css('left', 0);
    //         console.log(456);
    //     }
    //     console.log(123);
    // }

    makePopover(this, vidID);
  });
}

function wistiaPopoverInit() {
  if ($('.video-popup-wrapper').length) {
    wistiaPopover();
  }
}

var _default = wistiaPopoverInit;
exports["default"] = _default;

},{}],23:[function(require,module,exports){
"use strict";

var _windowSizeCheck = _interopRequireDefault(require("./modules/windowSizeCheck"));

var _smoothScroll = _interopRequireDefault(require("./modules/smoothScroll"));

var _navigation = _interopRequireDefault(require("./modules/navigation"));

var _footer = _interopRequireDefault(require("./modules/footer"));

var _scrollEvents = _interopRequireDefault(require("./modules/scrollEvents"));

var _homeIndustries = _interopRequireDefault(require("./modules/homeIndustries"));

var _accordion = _interopRequireDefault(require("./modules/accordion"));

var _careersFilter = _interopRequireDefault(require("./modules/careersFilter"));

var _carousels = _interopRequireDefault(require("./modules/carousels"));

var _wistiaPopover = _interopRequireDefault(require("./modules/wistiaPopover"));

var _tabbedContent = _interopRequireDefault(require("./modules/tabbedContent"));

var _typingText = _interopRequireDefault(require("./modules/typingText"));

var _seeConference = _interopRequireDefault(require("./modules/seeConference2019"));

var _mapbox = _interopRequireDefault(require("./modules/mapbox"));

var _digitalGuide = _interopRequireDefault(require("./modules/digitalGuide"));

var _seeMoreResources = _interopRequireDefault(require("./modules/seeMoreResources"));

var _resourcesFilterSearch = _interopRequireDefault(require("./modules/resourcesFilterSearch"));

var _ebooks = _interopRequireDefault(require("./modules/ebooks"));

var _progressBarOnScroll = _interopRequireDefault(require("./modules/progressBarOnScroll"));

var _singleResources = _interopRequireDefault(require("./modules/single-resources"));

var _hubspot = _interopRequireDefault(require("./modules/hubspot"));

var _changingText = _interopRequireDefault(require("./modules/changingText"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function crScripts() {
  (0, _windowSizeCheck["default"])();
  (0, _smoothScroll["default"])();
  (0, _navigation["default"])();
  (0, _footer["default"])();
  (0, _scrollEvents["default"])();
  (0, _homeIndustries["default"])();
  (0, _accordion["default"])();
  (0, _careersFilter["default"])();
  (0, _carousels["default"])();
  (0, _wistiaPopover["default"])();
  (0, _tabbedContent["default"])();
  (0, _typingText["default"])();
  (0, _seeConference["default"])();
  (0, _mapbox["default"])();
  (0, _digitalGuide["default"])();
  /* Resources */

  (0, _seeMoreResources["default"])();
  (0, _resourcesFilterSearch["default"])();
  (0, _ebooks["default"])();
  (0, _progressBarOnScroll["default"])();
  (0, _singleResources["default"])();
  (0, _hubspot["default"])();
  (0, _changingText["default"])();
}

$(document).ready(function () {
  crScripts();
});

},{"./modules/accordion":1,"./modules/careersFilter":2,"./modules/carousels":3,"./modules/changingText":4,"./modules/digitalGuide":5,"./modules/ebooks":6,"./modules/footer":7,"./modules/homeIndustries":8,"./modules/hubspot":9,"./modules/mapbox":10,"./modules/navigation":11,"./modules/progressBarOnScroll":12,"./modules/resourcesFilterSearch":13,"./modules/scrollEvents":14,"./modules/seeConference2019":15,"./modules/seeMoreResources":16,"./modules/single-resources":17,"./modules/smoothScroll":18,"./modules/tabbedContent":19,"./modules/typingText":20,"./modules/windowSizeCheck":21,"./modules/wistiaPopover":22}]},{},[23]);
